import React, { useState } from "react";
import Dashboard from "./Dashboard";
import "../App.css";

const App = () => {
  return <Dashboard />;
};

export default App;
